import { KeyLocationsList } from "./KeyLocationsList";

export default KeyLocationsList;
